module.exports = __webpack_public_path__ + "img/reviews-image5.87a7ea30.jpg";